import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import dom from "../../../../dist/jsx-render/dom";
import { IWidgetComponent } from "./IWidgetComponent";
import { app } from "../../../Frame/App";
import { WidgetVideoTutorials } from "../Widgets/WidgetVideoTutorials";
import { PagePopup } from "../../PagePopup";
import { MsoTable } from "../../Table/MsoTable";
import { EditTypes } from "../../Table/EditTypes";
import { TableColumnTypes } from "../../Table/TableColumnTypes";
import { TableColumnAlign } from "../../Table/TableColumnAlign";
import { ITableColumn } from "../../Table/ITableColumn";
import { DynPopup } from "../../../Components/DynPopup";

export type WidgetVideoTutorialsComponentProps = {
    widget: WidgetVideoTutorials;
}

export class WidgetVideoTutorialsComponent extends JSXComponent implements IWidgetComponent {
    props: WidgetVideoTutorialsComponentProps;
    private table: MsoTable;
    private nameList: [];

    public element: HTMLElement =
        <div className="widget Background-Blur-90-MSO">
            <div className="title-row">
                <div className="title mr-auto">{(this.props.widget.props.title[`value${app.languageUpperCase}`] && this.props.widget.props.title[`value${app.languageUpperCase}`].trim().length > 0) ? this.props.widget.props.title[`value${app.languageUpperCase}`] : this.props.widget.props.title[`value${app.defaultLanguageUpperCase}`]}</div>
            </div>
            <div className="content-row">
                {this.renderTable()}
            </div>
        </div>;

    constructor(props: WidgetVideoTutorialsComponentProps) {
        super(props);
    }

    private Columns: ITableColumn[] = [
        { type: TableColumnTypes.Custom, dataField: "fileType", number: 1, headerText: "", fixedWidth: "20px" },
        { type: TableColumnTypes.String, dataField: "nameInLanguage", number: 2, headerText: Resources.Common.labelName, cssClass: "title-item", align: TableColumnAlign.Left, fireOnCellClick: true },
    ]

    renderTable(): HTMLElement {
        let rootId = "widget_videotutorials_" + app.createGuid();
        let div: HTMLElement = <div id={rootId} className="widget-videotutorials overflow-auto"></div>;
            this.table = new MsoTable(div, {
                loadOnCreate: false,
                enableScroll: true,
                rowsPerPage: 100,
                fixedLayout: true,
                fixedHeader: true,
                idField: "id",
                settingsName: "videotutorialId",
                editType: EditTypes.None,
                getCustomContent: (field: string, model: any): HTMLElement => {
                    if (field == "fileType") {
                        let val = model[field];
                        switch (val) {
                            case 0:
                                return <div className="fa fa-play-circle"></div>;
                            case 1:
                                return <div className="fa fa-file-pdf"></div>;
                        }

                        return <div className="fa fa-play-circle"></div>;
                    }
                },
                onCellClick: (field: string, id: number): void => {

                    this.nameList.forEach((item: any) => {
                        if (item.id == id) {
                            if (item.fileType === 0) {
                                window.open(app.resolveUrl(`~/Videos?id=${id}`), "Video Player", app.videoWindowDimensions);
                            }
                            else {
                                window.open(app.resolveUrl(`~/videos/${item.link}`), '_blank', 'width=500, height=600, location=no, status=yes, resizable=yes, scrollbars=yes');
                            }
                        }
                    });
                    
                }
            });

        return div;
    }

    public render(): HTMLElement {
        this.props.widget.setGridPosition();
        this.loadData();
        return this.element;
    }

    private loadData() {

        if (this.props.widget.props.selectedVideoTutorialIds) {
            let selectedData = JSON.stringify(this.props.widget.props.selectedVideoTutorialIds);
            $.ajax({
                type: "GET",
                url: app.resolveUrl(`~/api/widget/getSelectedVideoTutorials/${selectedData}`),
                dataType: 'json',
                contentType: "application/json; charset=utf-8",
                success: (response) => {
                    this.nameList = response;
                    this.table.createAll(this.Columns, this.nameList, null, null);
                },
                error: ((response) => {
                    app.addError(response.statusText + ": " + response.responseText);
                })
            });
        }
    }
}